import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, pxToRem, size } from '@twistopayments/design-system/styles'

export const widget = (theme: Theme) => css`
  display: flex;
  gap: ${size[12]};
  align-items: center;
  padding: ${size[12]};
  border-radius: ${theme.borderRadius.md};
  width: max-content;

  p,
  span {
    font-size: ${pxToRem(18)};
    font-weight: 500;
    line-height: 1.25;
  }

  img {
    width: ${size[80]};
    height: ${size[80]};

    ${breakpoint.up('smMd')} {
      width: ${size[96]};
      height: ${size[96]};
    }
  }
`

export const reversedWidget = css`
  flex-direction: row-reverse;
`

export const clickableWidget = css`
  cursor: pointer;
`
